import React from 'react';
import { Consumer } from 'contexts/LocalStorage/LocalStorageContext';

export default (...args) => Component => props => (
    <Consumer>
        {({ createActions }) => (
            <Component {...props} {...createActions(...args)} />
        )}
    </Consumer>
);
